const VALID_HOME_ROUTES = ['/dashboard', '/chat'] as const;
type HomeRoute = typeof VALID_HOME_ROUTES[number];

export function getHomeRoute(): HomeRoute {
  const stored = localStorage.getItem('homeRoute');
  if (stored && VALID_HOME_ROUTES.includes(stored as HomeRoute)) {
    return stored as HomeRoute;
  }
  return '/dashboard';
}

export function setHomeRoute(route: HomeRoute): void {
  localStorage.setItem('homeRoute', route);
}
